<template>
  <div
    :class="{
      'orders-wrapper': atLeastOneModeActive,
    }"
  >
    <Navbar
      v-if="!isDesktop"
      @desktopNavigate="onSwitchMode"
      :currentMode="current_mode"
    />
    <NavbarDesktop
      v-else
      :currentView="currentView"
      @desktopNavigate="onSwitchMode"
      @createOrder="showCreateOrderUi"
      @onDiscardAction="discardAction"
      @onConfirmAction="confirmAction"
      :cart="cart"
      :action="action"
      :currentMode="current_mode"
    />
    <div class="not-ready" v-if="!atLeastOneModeActive">
      {{ $t("queue.modes_not_setup") }}
    </div>

    <div class="blur-box" v-show="activeModesCount > 1">
      <ModeSwitcher
        v-if="atLeastOneModeActive"
        class="orders-mode-switcher"
        :current="current_mode"
        :counters="counters"
        :cafe="cafe"
        @switch="onSwitchMode"
      />
    </div>

    <div
      v-if="atLeastOneModeActive"
      :class="{
        'orders-content': true,
        'orders-content-single': activeModesCount <= 1,
      }"
    >
      <OrdersQueue
        ref="OrdersQueue"
        @setCart="setCart"
        @selectTable="selectedTable"
        @dishSelect="dishSelect"
        @addDish="addDishEvent"
        v-if="current_mode == 'inside'"
      />
      <Preorder ref="Preorder" v-if="current_mode == 'preorder'" />
      <Delivery ref="Delivery" v-if="current_mode == 'delivery'" />
      <Reserve ref="Reserve" v-if="current_mode == 'reserve'" />
      <Hotels ref="Hotels" v-if="current_mode == 'hotels'"/>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";
import ModeSwitcher from "@/components/ModeSwitcher.vue";

import OrdersQueue from "@/views/OrdersQueue.vue";
import Preorder from "@/views/Preorder.vue";
import Delivery from "@/views/Delivery.vue";
import Reserve from "@/views/Reserve.vue";
import Hotels from "@/views/Hotels.vue"

export default {
  data() {
    return {
      current_mode: "inside",
      action: {
        type: "empty",
      },
      cart: 0,
      currentView: "menu",
    };
  },
  methods: {
    setCart(cart) {
      this.cart = cart;
    },
    confirmAction() {
      if (this.action.type == "selectDish" && this.cart) {
        this.$refs.OrdersQueue.addManyFromNavBar();
        this.action.type = "empty";
        this.cart = 0;
      }
      this.$refs.OrdersQueue.confirmFromNavbar();
      this.action.type = "selectDish";
    },
    dishSelect() {
      this.action.type = "product-selected";
    },
    addDishEvent(actions) {
      this.action.type = "selectDish";
    },
    discardAction(type) {
      this.$refs.OrdersQueue.hideModalUI(type);
      this.$refs.OrdersQueue.hideModalUI("add_dish");
      this.action.type = "empty";
    },
    selectedTable(section, table) {
      this.action.type = "selectTable";
      this.$refs.OrdersQueue.hideModalUI("create");

      this.$router.push({
        name: "create_order",
        params: {
          section,
          table,
        },
      });
    },
    handleResize(event) {
      this.clientWidth = window.innerWidth;
    },
    onSwitchMode(mode) {
      this.current_mode = mode;
    },
    showCreateOrderUi() {
      this.$refs.OrdersQueue.showOrderCreateUI();
      this.action.type = "createOrder";
    }
  },
  components: {
    Navbar,
    ModeSwitcher,
    OrdersQueue,
    Preorder,
    Delivery,
    NavbarDesktop,
    Reserve,
    Hotels
  },
  mounted() {
    this.clientWidth = window.innerWidth;
    window.addEventListener("resize", this.handleResize);
    this.$store.dispatch("init").then(() => {
    try {
        if (this.isDesktop) this.$store.dispatch('bootIntercom', {
          isDesktop: this.isDesktop
        });
      } catch(ir) {
        console.error(`[IntercomInit] Error: `, ir);
      } 
    }).catch(err => {
      const saved_qid = window.localStorage.getItem(`last_qid`);
      const suffix = saved_qid ? '/' + saved_qid : '';
      this.$router.push('/login'+suffix);
    });
    window.document.body.style.backgroundColor = "#ededed";

    this.$nextTick(() => {
      if (this.$route.query.m) {
        this.onSwitchMode(this.$route.query.m);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    counters() {
      return {
        inside: this.$store.state.queue.orders.length,
        preorder: this.$store.getters["preorder/preordersOnly"].length,
        delivery: this.$store.getters["preorder/deliveriesOnly"].length,
        reserve: this.$store.getters['reserve/needAttentionCount']
      };
    },
    cafe() {
      return this.$store.state.cafe;
    },
    activeModesCount() {
      return this.$store.getters["activeModesCount"];
    },
    atLeastOneModeActive() {
      return this.activeModesCount > 0;
    },
    isDesktop() {
      return window.innerWidth > 768;
    },
  },
};
</script>

<style scoped>
.orders-wrapper {
  width: 100%;
  background: #ededed;
  height: 100vh;
}

.not-ready {
  position: fixed;
  z-index: 10;
  text-align: center;
  top: 50vh;
  left: 0;
  width: 80%;
  margin: 0 auto;
  font-size: 2.3vh;
  right: 0;
  color: #e2223b;
  height: 100vh;
  overflow-y: hidden;
}

.orders-content {
  padding-top: 18vh;
}

.orders-content-single {
  padding-top: 8vh;
}

.pt-5 {
  padding-top: 7vh !important;
}

.blur-box {
  background: transparent;
  width: 100%;
  height: 17vh;
  backdrop-filter: blur(3px);
  position: fixed;
  z-index: 2;
}

.btn-create-order {
  margin: 3vh auto 0;
  width: 90%;
  font-size: 4.3vw;
  color: #1d1d1d;
  line-height: normal;
  font-weight: 500;
  display: block;
  padding: 1.5vh 0;
  border: 1px solid #1d1d1d;
  background: transparent;
  border-radius: 5vh;
}

@media screen and (min-width: 768px) {
  .orders-mode-switcher,
  .blur-box {
    display: none;
  }

  .orders-wrapper {
      overflow: hidden;
      max-height: 100vh;
  }
   
  .orders-content {
    padding-top: 0;
  }

  .not-ready {
    height: auto;
    width: 50%;
    margin: 0 auto;
    font-size: 3vh;
  }
}
</style>
